module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('DataTablePage', {
    ref: "collectorTable",
    attrs: {
      "mainColumn": "name",
      "longColumn": "type",
      "resource": "/nb/collector",
      "title": "采集设备管理",
      "label": "采集设备",
      "labelName": "name",
      "toolbar": _vm.toolbar,
      "operation": _vm.operation,
      "operationWidth": 115,
      "tableFullList": _vm.tableFullList,
      "tableInitList": _vm.tableInitList,
      "filterFullList": _vm.filterFullList,
      "filterInitList": _vm.filterInitList,
      "createList": _vm.createList,
      "updateList": _vm.updateList,
      "orderByInit": _vm.orderByInit,
      "columns": _vm.columns
    },
    on: {
      "checkGroupValue": _vm.checkGroupValue
    }
  }, [_c('div', {
    staticClass: "toolBar",
    attrs: {
      "slot": "toolbar"
    },
    slot: "toolbar"
  }, [_c('el-button', {
    staticClass: "header-bottom"
  }, [_c('a', {
    staticClass: "download",
    attrs: {
      "href": _vm.downLink,
      "download": "采集器模板"
    }
  }, [_vm._v("下载导入模板")])]), _c('el-upload', {
    staticClass: "btn-upload",
    attrs: {
      "accept": ".xls, .xlsx",
      "name": "uploadFile",
      "action": _vm.action,
      "show-file-list": false,
      "on-success": _vm.renderData,
      "headers": _vm.uploadHeader,
      "before-upload": _vm.beforeUpload
    }
  }, [_c('el-tooltip', {
    attrs: {
      "content": "只能上传excel文件",
      "enterable": false,
      "placement": "top"
    }
  }, [_c('el-button', {
    attrs: {
      "icon": "plus",
      "type": "primary"
    }
  }, [_vm._v("批量导入")])], 1)], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7f2a7542","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/containers/NB/Collector.vue
// module id = 1788
// module chunks = 1